import { Button, Empty, IconCirclePlus, LabeledGroup, useLocalization } from '@magicdoorinc/ui';
import { For } from 'solid-js';
import IconDelete from '~/assets/images/common/delete.svg?component-solid';
import type { LabeledGroupProps } from '@magicdoorinc/ui';

export const OptionsInput = (props: { value?: string[]; onInput?: (value: string[]) => void } & LabeledGroupProps) => {
  const { t } = useLocalization();
  const handleRemove = (index: number) => {
    props.onInput?.(props.value?.filter((_, i) => i !== index) ?? []);
  };

  const handleAdd = () => {
    props.onInput?.([...(props.value ?? []), ' ']);
  };

  const handleInput = (index: number, value: string) => {
    const newOptions = [...(props.value ?? [])];
    newOptions[index] = value.trim();
    props.onInput?.(newOptions);
  };

  return (
    <LabeledGroup label={props.labelJSX} error={props.error}>
      <div class="border-inputbox-border flex flex-col gap-4 rounded-md border p-4">
        <For each={props.value ?? []} fallback={<Empty class="p-0" description={t('No options')} />}>
          {(value, index) => (
            <div class="flex items-center gap-2">
              <div class="flex w-full flex-1 overflow-hidden rounded-md border bg-white transition focus-within:ring-1 focus-within:ring-primary">
                <input
                  class="w-full flex-1 bg-transparent px-3 py-2 text-sm text-black outline-none placeholder:text-text-disabled"
                  type="text"
                  value={value}
                  onChange={(e) => handleInput(index(), e.target.value)}
                  placeholder={t('Please enter')}
                />
              </div>
              <Button variant="text" size="sm" onClick={() => handleRemove(index())}>
                <IconDelete />
              </Button>
            </div>
          )}
        </For>
        <Button
          onClick={handleAdd}
          variant="outlined"
          color="primary"
          rounded="full"
          size="sm"
          class="inline-flex justify-center self-center">
          <IconCirclePlus />
          {t('Add option')}
        </Button>
      </div>
    </LabeledGroup>
  );
};
